export const Frequencies = {
    Annually: {
        value: 'Annually',
        text: 'Annually',
    },
    Quarterly: {
        value: 'Quarterly',
        text: 'Quarterly',
    },
    Monthly: {
        value: 'Monthly',
        text: 'Monthly',
    },
    Weekly: {
        value: 'Weekly',
        text: 'Weekly',
    },
    Daily: {
        value: 'Daily',
        text: 'Daily',
    },
    AdHoc: {
        value: 'AdHoc',
        text: 'Ad Hoc',
    },
};
